import { render, staticRenderFns } from "./contraenti.vue?vue&type=template&id=0d6f3890&"
import script from "./contraenti.vue.ts?vue&type=script&lang=ts&"
export * from "./contraenti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports